import type { IconSvgObject } from './types';

const YoutubeIcon: IconSvgObject = [
  ["path", { d: "M15 12L10 9V15L15 12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.8518 4.44087C16.7618 4.15764 14.4422 4 12 4C9.55778 4 7.23825 4.15764 5.14822 4.44087C3.29493 4.69202 2 6.32845 2 8.19868V15.8013C2 17.6715 3.29493 19.308 5.14822 19.5591C7.23825 19.8424 9.55778 20 12 20C14.4422 20 16.7618 19.8424 18.8518 19.5591C20.7051 19.308 22 17.6715 22 15.8013V8.19869C22 6.32845 20.7051 4.69202 18.8518 4.44087Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default YoutubeIcon;
